module.exports = __webpack_public_path__ + "static/media/icon-download-white.825566ee.svg";